import * as React from "react";
import {PropsWithChildren} from "react";

interface Props {
    anbieter: string[]

};

interface State {
    checked: boolean
}

export default class ReactAnbieter extends React.Component<PropsWithChildren<Props>, State> {
    constructor(props: Props) {

        super(props);
        this.state = {checked: false};
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(checked: boolean) {
        this.setState({checked});
    }

    render() {
        return (
            <div>
                {this.props.anbieter.map(function(overlay){
                    return <div className="anbietervalue" key={overlay}>{overlay}</div>
                })}
            </div>
        );
    }
}